import { Component, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialog} from '@angular/material/dialog';
import {MsgDialog} from "../dialog/message-dialog/message-dialog.component";
import {HttpService} from "../services/http/http.service";
@Component({
  selector: 'app-user-area',
  templateUrl: './user-area.component.html',
  styleUrls: ['./user-area.component.scss']
})
export class UserAreaComponent implements AfterViewInit {
  showUserHeader: boolean = true;
  userInfo: any;
  constructor(private router: Router, public dialog: MatDialog, public api: HttpService) { }
  ngAfterViewInit(): void {
    this.router.events.subscribe((ev) => {
      if (ev instanceof NavigationEnd) {
        this.userInfo = sessionStorage.getItem('userInfo');
        this.userInfo = JSON.parse(this.userInfo);
        this.showUserHeader = (this.router.url !== '/');
      }
    });
  }

  logout() {
    this.api.getUrlRedirect().subscribe({
      next: data => {
        sessionStorage.clear();
        window.location.href = data.descrizione;
      }
    })
  }

  openMsgDialog(): void {
    const dialogRef = this.dialog.open(MsgDialog, {
      data: ''
    });
    dialogRef.afterClosed().subscribe((result: any) => {

    })
  }
}
